module.exports = __webpack_public_path__ + "img/logo.0723d9e2.svg";